import { templateLicenseTrialSubForm } from '../view/template';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { LicenseTrialSubFormWebComponent } from '../component/LicenseTrialSubFormWebComponent';
import { LicenseTrialSubFormView } from '../view/LicenseTrialSubFormView';

export class LicenseTrialSubFormController extends BaseWebComponentController {
  public component: LicenseTrialSubFormWebComponent;
  public view: LicenseTrialSubFormView;
  public viewConstructor: typeof LicenseTrialSubFormView;

  constructor(component: LicenseTrialSubFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: LicenseTrialSubFormView,
      viewTemplate: templateLicenseTrialSubForm,
    });
  }
}
